import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base.query';
import { API, API_PREFIX } from '../../constants';

export interface AttachmentResponse {
  base64String: string;
  fileMimeType: string;
}

export interface WidgetAttachmentRequest {
  imageId: string;
  responseId: string;
}

export const dataGridApi = createApi({
  reducerPath: 'dataGridApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAttachment: builder.mutation<AttachmentResponse, WidgetAttachmentRequest>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.GET_RESPONSE_IMAGE}/${args.imageId}?responseId=${args.responseId}`,
      }),
    }),
  }),
});

export const { useGetAttachmentMutation } = dataGridApi;
